
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useTranslatedText } from "@/hooks/useTranslate";

const FAQSection = () => {
  const titleText = useTranslatedText("Preguntas Frecuentes");
  const subtitleText = useTranslatedText("Resolvemos las dudas más comunes sobre nuestros servicios");

  const faqData = [
    {
      question: useTranslatedText("¿Cuánto tiempo toma desarrollar una aplicación web?"),
      answer: useTranslatedText("El tiempo de desarrollo varía según la complejidad del proyecto. Una aplicación web básica puede tomar entre 4-6 semanas, mientras que proyectos más complejos pueden requerir 3-6 meses.")
    },
    {
      question: useTranslatedText("¿Ofrecen soporte después del lanzamiento?"),
      answer: useTranslatedText("Sí, ofrecemos diferentes planes de soporte post-lanzamiento que incluyen mantenimiento, actualizaciones de seguridad, y soporte técnico continuo.")
    },
    {
      question: useTranslatedText("¿Trabajajan con empresas de todos los tamaños?"),
      answer: useTranslatedText("Absolutamente. Trabajamos con startups, PYMES y grandes empresas, adaptando nuestras soluciones a las necesidades específicas de cada cliente.")
    },
    {
      question: useTranslatedText("¿Qué tecnologías utilizan?"),
      answer: useTranslatedText("Utilizamos tecnologías modernas como React, Node.js, Python, y frameworks de vanguardia para garantizar aplicaciones escalables y de alto rendimiento.")
    },
    {
      question: useTranslatedText("¿Proporcionan hosting para las aplicaciones?"),
      answer: useTranslatedText("Sí, ofrecemos soluciones de hosting escalables y seguras, o podemos trabajar con su proveedor de hosting preferido.")
    },
    {
      question: useTranslatedText("¿Cómo es el proceso de desarrollo?"),
      answer: useTranslatedText("Seguimos una metodología ágil: análisis de requisitos, diseño, desarrollo iterativo, pruebas, y despliegue. Mantenemos comunicación constante durante todo el proceso.")
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-techno-dark via-slate-900 to-techno-dark">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            {titleText}
          </h2>
          <p className="text-gray-300 text-lg max-w-2xl mx-auto">
            {subtitleText}
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          <Accordion type="single" collapsible className="space-y-4">
            {faqData.map((faq, index) => (
              <AccordionItem
                key={index}
                value={`item-${index}`}
                className="bg-card-gradient border border-purple-500/20 rounded-xl px-6 data-[state=open]:border-purple-500/40 transition-all duration-300"
              >
                <AccordionTrigger className="text-white hover:text-techno-purple text-left py-6 text-lg font-medium">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-gray-300 text-base leading-relaxed pb-6">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>

        <div className="text-center mt-12">
          <p className="text-gray-400 mb-4">
            {useTranslatedText("¿No encuentras la respuesta que buscas?")}
          </p>
          <a 
            href="/contacto" 
            className="inline-block bg-gradient-to-r from-techno-purple to-techno-accent text-white px-8 py-3 rounded-lg hover:opacity-90 transition-opacity duration-300 font-medium"
          >
            {useTranslatedText("Contáctanos")}
          </a>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
